export default {"src":"/_next/static/media/0x5ca135cb8527d76e932f34b5145575f9d8cbe08e.aa31c68b.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};